import { Grid, SimpleGrid } from '@mantine/core';
import { CText } from './CText';
import { ContentContainer } from './ContentContainer';
import classes from './MainLayout.Footer.module.scss'

export const MainLayoutFooter = () => {
  return <div className={classes.container}>
    <ContentContainer pt='lg' pb='lg'>
      <Grid>
        <Grid.Col span={4}>
          <CText type='title'>CONTACT</CText>
        </Grid.Col>
        <Grid.Col span={4}>
          <CText type='title'>QUICK LINKS </CText>
        </Grid.Col>
        <Grid.Col span={4}>
          <CText type='title'>EXPERIENCE</CText>

        </Grid.Col>
      </Grid>
    </ContentContainer>;
  </div>
}